import { useCallback } from 'react';
import { useDrawerContext } from '@app/components/dialogs/DrawerProvider';
import BalanceFilters from '@widgets/balance/BalanceFilters';
import TransactionsFilter from '@widgets/transactions/TransactionsFilter';
import NotificationsDrawer from '@widgets/sidebar/NotificationsDrawer';
import CardsFilters from '@widgets/cards/CardsFilters';
import ReferralsBalanceHistory from '@widgets/referrals/ReferralsBalanceHistory';

function createDrawerHook(openFnName, component, options = {}) {
  return function useDrawer() {
    const { openDrawer } = useDrawerContext();

    const open = useCallback(
      () => openDrawer(component, options),
      [openDrawer],
    );

    return { [openFnName]: open };
  };
}

export const useBalanceFilters = createDrawerHook(
  'openBalanceFilters',
  BalanceFilters,
  { title: 'filters' },
);

export const useTransactionsFilters = createDrawerHook(
  'openTransactionsFilters',
  TransactionsFilter,
  { title: 'filters' },
);

export const useNotificationsDrawer = createDrawerHook(
  'openNotificationsDrawer',
  NotificationsDrawer,
  { title: 'notifications', anchor: 'left' },
);

export const useCardsFilters = createDrawerHook(
  'openCardsFilters',
  CardsFilters,
  { title: 'filters' },
);

export const useReferralsBalanceHistory = createDrawerHook(
  'openReferralsBalanceHistory',
  ReferralsBalanceHistory,
  { title: 'balance_history', className: 'drawerFilter--wide' },
);
